const dtGenerator = require('../../../../../components/dt/dt-generator');
const dtHandler = require('../../../../../components/dt/dt-handler');
const itemDtSelect = require('./item-dt-select');
const itemMenu = require('./item-menu');
const { organizeRow } = require('./item-dt-handler');
const { tableDetail } = require('./item-dt-handler');
const dtInventoryHandler = require('./item-dt-handler');
const dtUpdateHandler    = require('./item-dt-update')
const treemap = require('./chart/item-treemap-chart');
const inf = require('../../../../../js-network/inf');
const dbRequest = require('../../../../../js-network/db-request');
const inventorySocket = require('./item-inventory-web-socket');

const ITEM_TREEMAP_LIMIT = 40;
const INITIAL_ROWS = 20;


/****************ELEMENTS*****************/
var htmlDt = {};
var HTMLwasSelected = false;
let lastItemSelectDetail = null;

function rememberSelectDetail(detail) {
	lastItemSelectDetail = detail;
}

function HTMLselect() {
	dtHandler.HTMLselect('item-dt', htmlDt, organizeRow, tableDetail);
	HTMLwasSelected = true;
}
/****************ELEMENTS*****************/

function refreshItemTreemap() {
	if (!lastItemSelectDetail || !htmlDt.footer) {
		return;
	}
	const detailTreemap = { ...lastItemSelectDetail };
	inf.toSelect(detailTreemap, htmlDt);
	detailTreemap.inf = Object.assign({}, detailTreemap.inf, { limit1: 0 });
	detailTreemap.inf = Object.assign({}, detailTreemap.inf, { limit2: ITEM_TREEMAP_LIMIT });

	dbRequest
		.start(detailTreemap, 'server/php/sql/select.php')
		.then((result) => {
			if (result.status === 'ok' && Array.isArray(result.data)) {
				treemap.createTreemapChart(result.data);
			}
		})
		.catch(() => { });
}

function afterTableSelect(result) {
	refreshItemTreemap();
	addTotalAmountTab(result);
}



// agregar el total en inventario en el tab de inventory
function addTotalAmountTab(result) {
	if (result.length === 0) {
		document.getElementById('labelItem').textContent = 'Item ($0.00)';
		return;
	}

	const totalAmount = result[0].total_amount;
	document.getElementById('labelItem').textContent = `Item (${totalAmount})`;
}

export function start(detail) {
	// Un mensaje puede llegar aunque el usuario no tenga abierto Item.
	if (detail.act === 'refreshInventory' && !document.getElementById('item-dt')) return;
	if (!HTMLwasSelected) {
		HTMLselect();
	}

	obj[detail.act].start(detail);
}

const obj = {
	refreshInventory: {
		start: async (detail) => {
			const updated = await inventorySocket.applyInventoryChanges(detail, htmlDt);
			// El chart vuelve a consultar sus datos completos con los filtros actuales.
			if (updated) refreshItemTreemap();
		}
	},
	//From fullcont connection
	addRow: {
		start: (detail) => {
			dtGenerator.addRow(detail, htmlDt);
		}
	},
	tableOptions: {
		start: (detail) => {
			itemMenu.start(detail, htmlDt, 'htmlFc');
		}
	},
	trMenu: {
		start: (detail) => {
			itemMenu.start(detail, htmlDt, 'htmlFc');
		}
	},
	updateRow: {
		start: (detail) => {
			dtGenerator.updateRow(detail, htmlDt);
		}
	},

	//data table (item-local select stack + treemap refresh)
	filter: {
		start: (detail) => {
			rememberSelectDetail(detail);
			itemDtSelect.filter(detail, htmlDt);
		}
	},
	filterShowHide: {
		start: (detail) => {
			rememberSelectDetail(detail);
			itemDtSelect.filterShowHide(detail, htmlDt);
		}
	},
	loadMore: {
		start: (detail) => {
			rememberSelectDetail(detail);
			itemDtSelect.loadMore(detail, htmlDt);
		}
	},
	searching: {
		start: (detail) => {
			rememberSelectDetail(detail);
			itemDtSelect.searching(detail, htmlDt, undefined);
		}
	},
	select: {
		start: (detail) => {
			rememberSelectDetail(detail);
			selectInitial(detail);
		}
	},
	th: {
		start: (detail) => {
			rememberSelectDetail(detail);
			itemDtSelect.th(detail, htmlDt);
		}
	},
	trPrint: {
		start: (detail) => {
			trPrint(detail);
		}
	},
	showAllItem:				{ start: (detail) =>	{ dtInventoryHandler.showAllItem(htmlDt, detail)		} },
	dialogUpdateSellingPrice:	{ start: (detail) =>	{ dtInventoryHandler.dialogUpdateSellingPrice(detail)	} },
	confirmUpdateSellingPrice:	{ start: (detail) =>	{ dtInventoryHandler.confirmUpdateSellingPrice(detail)	} },
	updateSellingPrice:			{ start: (detail) =>	{ dtUpdateHandler.updateSellingPrice(detail)			} },

};

function selectInitial(detail) {
	inf.toSelect(detail, htmlDt);
	detail.inf.limit2 = INITIAL_ROWS;
	itemDtSelect.select(detail, htmlDt, true, (result, availableRowsWithFilters, resultComplete) => {
		htmlDt.footer.setAttribute('data-limit', 10);
		afterTableSelect(result, availableRowsWithFilters, resultComplete);
	});
	detail.inf.limit2 = 10;
}

function trPrint(detail) { }
